// extracted by mini-css-extract-plugin
export var standaloneTable = "_fb-0";
export var withExtraHeader = "_fb-1";